var r;(r||(r={})).sdkVersion=function(){return"6.21.0"};export{r as DataCaptureVersion};